'use client';
import { DMButton } from '@/components/button';
import DMInput from '@/components/input/TextInput';
import { DMLink } from '@/components/link';
import { PasswordInput } from '@/components/ui/password-input';
import { zodResolver } from '@hookform/resolvers/zod';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ErrorMessage, SignInSchema, SignInSchemaType } from './types/signin';
import { DMAlertDialog } from '@/components/alert-dialog';

const LoginWithEmail: React.FC = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertDescription, setAlertDescription] = useState('');
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<SignInSchemaType>({ resolver: zodResolver(SignInSchema) });

  const onSubmit: SubmitHandler<SignInSchemaType> = async data => {
    const response = await signIn('credentials', {
      email: data.email,
      password: data.password,
      redirect: false,
    });
    if (!response?.error) {
      router.refresh();
    } else {
      setShowAlert(true);
      setAlertDescription('Incorrect Email/Password');
      setAlertTitle('Login failed');
    }
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col m-px gap-4 w-full items-start flex-1"
    >
      <DMAlertDialog
        open={showAlert}
        setOpen={setShowAlert}
        title={alertTitle}
        description={alertDescription}
        buttonTitle="Ok"
      />
      <DMInput
        type="text"
        label="Email"
        placeholder="Enter Email"
        name="email"
        inputMode="text"
        extra="w-full"
        register={register('email')}
        errorMessage={errors.email as ErrorMessage}
      />
      <PasswordInput
        type="password"
        placeholder="Enter Password"
        name="password"
        inputMode="text"
        register={register('password')}
        errorMessage={errors.password as ErrorMessage}
      />

      <div className="w-full">
        <DMButton
          type="submit"
          className="relative w-full py-3 text-center flex justify-center mt-2"
          variant="primary"
          disabled={isSubmitting}
          loading={isSubmitting}
        >
          Login
        </DMButton>
        <DMLink
          href="/forgot-password"
          variant="text"
          className="text-xs font-semibold text-right w-full float-right text-gray-300 mt-2"
        >
          Forgot Password
        </DMLink>
      </div>
    </form>
  );
};

export default LoginWithEmail;
